export const TURBO_MODE_PROGRAM_NAME = (propertyId: number) =>
  `Internal-Turbo-mode-${propertyId}`;
export const MODE_CHANGE_PROGRAM_NAME = "Internal-mode-change";
export const DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ssZ";
